import React from 'react';
import { Typography, Box } from '@mui/material';

const SFNoData = ({
    title,
    description
}) => {
    return (
        <Box mt={3} textAlign="center">
            <Typography variant="h5" style={{ color: '#bb0000', fontWeight: 500 }} gutterBottom>
                {title}
            </Typography>
            <Typography variant="subtitle1">
                {description}
            </Typography>
        </Box>
    );
}

export default SFNoData;
